export default class LoadingController {
  /* @ngInject */
  constructor(NetworkService) {
    this.NetworkService = NetworkService;
  }
}



// WEBPACK FOOTER //
// ./src/components/loading/loading.controller.js